import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bbcedd3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import { nextTick, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    left: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
    (e: "click"): void;
}), expose: any, slots: any, attrs: any }) {




const activated = ref(false);
const activatedTimeout = ref<number | null>(null);

function click() {
    emit("click");

    // Give feedback to user
    if (activatedTimeout.value) {
        clearTimeout(activatedTimeout.value);
    }
    activated.value = false;
    nextTick(() => {
        activated.value = true;
        activatedTimeout.value = setTimeout(() => (activated.value = false), 500);
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _withModifiers(click, ["stop"]),
    class: _normalizeClass(["feedback", { activated: activated.value, left: __props.left }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})